export const CompanyConfig = {
  name: 'Collector Car Leaders',
  shortName: 'CCL',
  logoUrl: '/assets/images/logo-header.png',
  phone: '800-224-8180',
  website: 'https://www.collectorcarleaders.com',
  privacyUrl: 'https://www.collectorcarleaders.com/privacy',
  termsUrl: 'https://www.collectorcarleaders.com/terms-of-use',
  contactUrl: 'https://www.collectorcarleaders.com/contact',
  dealerFormUrl: 'https://www.collectorcarleaders.com/form-submitted',
  formSubmittedUrl: 'https://www.collectorcarleaders.com/form-submitted',
  paymentUrl: 'https://pay.collectorcarleaders.com', // TODO: env var
  dealerDocumentUrl: 'https://get-started.collectorcarleaders.com/upload-dealer-documents',
  leadFormBaseUrl: 'https://get-started.collectorcarleaders.com',
  adminEmail: 'credit@collectorcarleaders.com',
  address: {
    addressLine1: '3306 SW 26th Av #301',
    addressLine2: '',
    city: 'Ocala',
    state: 'FL',
    zipCode: '34471',
  },
  // TSF - how did you hear about us
  // export const referralSources = [
  //   "Google",
  //   "Friend/Family",
  //   "Dealership",
  //   "Facebook",
  //   "Instagram",
  //   "Other", //
  // ];
  referralSources: [
    'Google',
    'Friend/Family',
    'Dealership',
    'Returning Customer',
    'Hemmings',
    'All Collector Cars',
    'Facebook',
    'Instagram',
    'Other', //
  ],
};
